import { createSlice } from '@reduxjs/toolkit'

interface UsersState {
  token: string | null
  roles: string[]
  expiresAt: number | null
}

const initialState = {
  token: null,
  roles: [],
  expiresAt: null,
} satisfies UsersState as UsersState

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      state.token = action.payload.token
      state.roles = action.payload.roles
      state.expiresAt = action.payload.expires_at * 1000
    },
    removeUser(state) {
      state.token = null
      state.roles = []
      state.expiresAt = null
    },
  },
})

export const { setUser, removeUser } = userSlice.actions
export default userSlice.reducer
